import { createContext, useContext, useState } from "react";
import BookingModal from "../components/BookingModal";

const BookingContext = createContext();

export function BookingProvider({ children }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const [selectedCoupon, setSelectedCoupon] = useState("");

  const openBookingModal = (serviceName = "", couponCode = "") => {
    const safeService = typeof serviceName === "string" ? serviceName : "";
    const safeCoupon = typeof couponCode === "string" ? couponCode : "";
    setSelectedService(safeService);
    setSelectedCoupon(safeCoupon);
    setModalOpen(true);
  };

  const closeBookingModal = () => {
    setModalOpen(false);
  };

  return (
    <BookingContext.Provider value={{ openBookingModal, closeBookingModal, modalOpen }}>
      {children}
      <BookingModal
        isOpen={modalOpen}
        onClose={closeBookingModal}
        initialService={selectedService}
        initialCoupon={selectedCoupon}
      />
    </BookingContext.Provider>
  );
}

export function useBooking() {
  const context = useContext(BookingContext);
  if (!context) {
    return {
      openBookingModal: () => {},
      closeBookingModal: () => {},
      modalOpen: false
    };
  }
  return context;
}
